import React from 'react';

import '../assets/css/global-styles.css';

/**
 * This component returns null but provides a side effect
 * on importing global styles, to compose altogether with
 * MuiProvider and CssBaseline components
 */
export const GlobalStyles: React.FunctionComponent<{}> = (): null => null;
